import { useEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { useSelectedStore } from '../../stores';
import { DialogHost } from './sub-components/DialogHost';
import { Header } from './sub-components/header';
import { SideBar } from './sub-components/side-bar';

export const DefaultLayout2 = () => {
    const headerRef = useRef<HTMLDivElement>(null);
    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        const headerElement = headerRef.current;
        if (!headerElement) {
            return;
        }

        const setHeight = () => setHeaderHeight(headerElement.offsetHeight);
        const observer = new ResizeObserver(setHeight);

        setHeight();
        observer.observe(headerElement);

        return () => observer.disconnect();
    }, []);

    const { workspace } = useSelectedStore();
    const isWorkspaceSelected = !!workspace;

    return (
        <div className="bg-background w-full min-h-screen">
            <SideBar />
            <div className="min-h-screen flex flex-col w-full">
                <Header headerRef={headerRef} />
                <main
                    className={`flex-1 overflow-y-auto flex flex-col items-center max-h-screen transition-[padding-left] duration-250 ease-out ${
                        isWorkspaceSelected ? 'md:pl-[60px]' : ''
                    }`}
                    style={{ paddingTop: `${headerHeight}px` }}
                >
                    <Outlet />
                </main>
            </div>
            <DialogHost />
        </div>
    );
};
